import styled from "styled-components";
import { COLORS } from "../../../../../styles/constants.style";

export const GenericAccountsSearchResultWrapper = styled.div`
  margin: 19px 0px 39px;

  .form-header {
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiPaper-root.MuiTableContainer-root {
    border-radius: 0;
  }

  .MuiGrid2-root {
    width: 100%;
  }
  .client {
    width: 200px;
  }

  .purpose {
    width: 150px;
  }
  .cell-client {
    min-width: 200px;
  }
`;
